<template>
	<v-card class='elevation-0 events-page page'>
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
			<div class='events-page__wrap'>
				<div>
					<div class='d-flex align-center event__search px-4 mb-7'>
						<div class='d-flex w-100 mr-6 align-center' style='width: 100%'>
							<input
								type='text'
								class='post-preview-card__comment'
								placeholder='Search'
								v-model='filters.search'
								@input='filterSearch'
							/>
						</div>
						<img :src='searchIcon' alt='' />
					</div>
				</div>
	
				<div
					v-if="isShowChips"
				>
					<div>
						<v-btn
							v-for='chipItem in normalizedFeedFilterChips'
							:key="chipItem.content"
							@click='getAndCallDynamicFunction(chipItem.name)'
							class='post__btn-filters'
							:class="{ 'post__btn-filters-active': isButtonActive(chipItem.name) }"
						>{{ chipItem.content }}
						</v-btn
						>
					</div>
				</div>
	
				<PostFilterModal
					v-on:closeModal='closeModal'
					:show='showModal'
	
					entityType='events'
	
					:error='error'
					:show-error='showError'
					:close-alert='closeAlert'
	
					:selected-button='selectedButton'
					:current-active-button='this.currentActiveButton'
					:chipsLists='this.lists'
					:currentActiveButtonTitle='currentActiveButtonTitle'
					@applySelection='applySelection'
					@setItems='setSelectedItems'
				/>
	
			</div>
	
			<div class='d-flex'>
	
				<v-skeleton-loader
					v-if='isLoading || isCategoryIdNotSet'
					v-bind='attrs'
					width='600'
					type='list-item, list-item-three-line, card-heading'
				></v-skeleton-loader>
	
				<div v-else style='width: 100%' class='mt-10'>
					<div v-for='(dir, index) in directoriesNormalize' :key='index'>
						<router-link
							:to="{
								name: 'directory-by-id',
								params: {
									id: dir.directory_id
								},
								query: {
									category_id: categoryId
								}
							}"
							class="text-decoration-none"
						>
							<DirectoryPreview :directory='dir' />
						</router-link>
					</div>
				</div>
			</div>
	
	
			<div class='d-flex my-9 justify-center home-page__pagination'
				v-if='!isLoading && directories.length > 0 && !isCategoryIdNotSet'
			>
				<Pagination 
					:page="filters.page"
					:pageCount="+this.pageDirectories"
					v-on:pageChange="onPageChange"
				/>
			</div>
	
			<div class='d-flex my-9 justify-center home-page__pagination'
				v-if='!isLoading && directories.length <= 0 && !isCategoryIdNotSet'
			>
				<NewsFeedEmpty
					title="Directories not found at this moment."
					description="Check back later."
					centering="center"
				/>
			</div>
	
			<v-btn
				v-show='isVisible'
				@click='scrollToTop'
				bottom
				right
				fixed
				fab
			>
				<v-icon>mdi-chevron-up</v-icon>
			</v-btn>
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import DirectoryPreview from '@/components/Directory/DirectoryPreview'
import searchIcon from '@/assets/images/search.svg'
import PostFilterModal from '@/components/Modals/PostFilterModal'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty'
import Pagination from '@/components/Pagination.vue'
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'
import _ from 'lodash'

const DEBOUNCE_TIMEOUT = 500


export default {
	name: 'DirectoriesPage',
	mixins: [Block],
	components: {
		PostFilterModal,
		NewsFeedEmpty,
		DirectoryPreview,
		Pagination,
		PageBlocked
	},
	methods: {
		...mapActions('post', ['fetchPosts', 'getFeaturedPost', 'getViolationsList']),
		...mapActions('event', ['fetchEvents', 'getAttendeesEvent', 'clearAttendeesEvent']),
		...mapActions('directory', ['getDirectories']),
		...mapActions('list', ['getListsMeta', 'getList', 'clearLists']),

		toggleVisibility() {
			this.isVisible = window.scrollY > 1000
		},
		isButtonActive(name) {
			return this.selectedButton.includes(
				name.replace(/-/g, "_")
			)
		},
		scrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			})
		},
		closeAlert() {
			this.showError = false;
			this.error = ''
		},

		clearButtonHandler() {
			this.currentActiveButton = 'clear'
			this.selectedButton = ['clear']

			this.selectedChapters = []
			this.selectedDirIndexColumn1 = []
			this.selectedDirIndexColumn2 = []
			this.selectedDirIndexColumn3 = []
			this.selectedEmploymentTypes = []

			this.filters = {
				filter: null,
				groups: [],

				employmentTypes: [],
				dirIndexColumn1: [],
				dirIndexColumn2: [],
				dirIndexColumn3: [],

				search: this.filters.search,
			}
			this.showModal = false
		},
		followButtonHandler() {
			this.currentActiveButton = 'follow'
			const mutuallyExclusiveButtons = ['clear']

			this.selectedButton = this.getFilteredChips(
				this.selectedButton,
				this.currentActiveButton,
				mutuallyExclusiveButtons
			)

			const isHandleButtonActive = this.selectedButton.includes(this.currentActiveButton)

			this.filters = {
				...this.filters,
				filter:  isHandleButtonActive ? 'follow' : null,
			}
		},

		chaptersButtonHandler() {
			this.currentActiveButton = 'chapters'

			this.currentActiveButtonTitle = this.normalizedFeedFilterChips.find(
				item => item.name === this.currentActiveButton
			).content

			const mutuallyExclusiveButtons = ['clear']

			this.selectedButton = this.getFilteredChips(
				this.selectedButton,
				this.currentActiveButton,
				mutuallyExclusiveButtons
			)

			const isHandleButtonActive = this.selectedButton.includes(this.currentActiveButton)

			if (!isHandleButtonActive) {
				this.selectedChapters = []
				this.filters = {
					...this.filters,
					groups: [],
				}
			}

			this.showModal = isHandleButtonActive
		},

		dir_index_column1ButtonHandler() {
			this.currentActiveButton = 'dir_index_column1'

			this.currentActiveButtonTitle = this.normalizedFeedFilterChips.find(
				item => item.name === this.currentActiveButton
			).content

			const mutuallyExclusiveButtons = ['clear']

			this.selectedButton = this.getFilteredChips(
				this.selectedButton,
				this.currentActiveButton,
				mutuallyExclusiveButtons
			)

			const isHandleButtonActive = this.selectedButton.includes(this.currentActiveButton)

			if (!isHandleButtonActive) {
				this.selectedDirIndexColumn1 = []
				this.filters = {
					...this.filters,
					dirIndexColumn1: [],
				}
			}

			this.showModal = isHandleButtonActive
		},

		dir_index_column2ButtonHandler() {
			this.currentActiveButton = 'dir_index_column2'

			this.currentActiveButtonTitle = this.normalizedFeedFilterChips.find(
				item => item.name === this.currentActiveButton
			).content

			const mutuallyExclusiveButtons = ['clear']

			this.selectedButton = this.getFilteredChips(
				this.selectedButton,
				this.currentActiveButton,
				mutuallyExclusiveButtons
			)

			const isHandleButtonActive = this.selectedButton.includes(this.currentActiveButton)

			if (!isHandleButtonActive) {
				this.selectedDirIndexColumn2 = []
				this.filters = {
					...this.filters,
					dirIndexColumn2: [],
				}
			}

			this.showModal = isHandleButtonActive
		},

		dir_index_column3ButtonHandler() {
			this.currentActiveButton = 'dir_index_column3'

			this.currentActiveButtonTitle = this.normalizedFeedFilterChips.find(
				item => item.name === this.currentActiveButton
			).content

			const mutuallyExclusiveButtons = ['clear']

			this.selectedButton = this.getFilteredChips(
				this.selectedButton,
				this.currentActiveButton,
				mutuallyExclusiveButtons
			)

			const isHandleButtonActive = this.selectedButton.includes(this.currentActiveButton)

			if (!isHandleButtonActive) {
				this.selectedDirIndexColumn3 = []
				this.filters = {
					...this.filters,
					dirIndexColumn3: [],
				}
			}

			this.showModal = isHandleButtonActive
		},

		employment_typesButtonHandler() {
			this.currentActiveButton = 'employment_types'

			this.currentActiveButtonTitle = this.normalizedFeedFilterChips.find(
				item => item.name === 'employment-types'
			).content

			const mutuallyExclusiveButtons = ['clear']

			this.selectedButton = this.getFilteredChips(
				this.selectedButton,
				this.currentActiveButton,
				mutuallyExclusiveButtons
			)

			const isHandleButtonActive = this.selectedButton.includes(this.currentActiveButton)

			if (!isHandleButtonActive) {
				this.selectedEmploymentTypes = []
				this.filters = {
					...this.filters,
					employmentTypes: [],
				}
			}

			this.showModal = isHandleButtonActive
		},

		filterSpecifiedValues(list, filterValues) {
			return list.filter(item => !filterValues.includes(item))
		},

		getFilteredChips(
			selectedButtons,
			handleButtonName,
			mutuallyExclusiveButtons
		) {
			const isButtonPresentInlist = this.selectedButton.includes(handleButtonName)

			if (!isButtonPresentInlist) {
				return this.filterSpecifiedValues([...this.selectedButton, handleButtonName], mutuallyExclusiveButtons)
			} else {
				const filteredValues = this.filterSpecifiedValues(this.selectedButton, handleButtonName, [handleButtonName])

				if ( filteredValues.length <= 0 ) {
					return ['clear'];
				}

				return filteredValues;
			}
		},

		getAndCallDynamicFunction(name) {
			let stringWithUnderscores = name.replace(/-/g, "_");
			const dynamicFunctionName = `${stringWithUnderscores}ButtonHandler`
			const dynamicFunction = this[dynamicFunctionName]

			if (typeof dynamicFunction === 'function') {
				dynamicFunction()
			} else {
				console.error('Function not found')
			}
		},
		onPageChange(page) {
			if (this.filters.page !== page) {
				const params = {
					filter: this.filters.filter,
					chapter_id: this.filters.groups,
	
					dir_index_column1: this.filters.dirIndexColumn1,
					dir_index_column2: this.filters.dirIndexColumn2,
					dir_index_column3: this.filters.dirIndexColumn3,
					'employment-types': this.filters.employmentTypes,
	
					search: this.filters.search,
					page: page,
				}
				this.filters.page = page
				const queryString = this.formatFilters(params)
				this.getDirectories(queryString)
			}
		},

		formatFilters(filters) {
			const {
				filter = null,
				chapter_id = [],

				dir_index_column1,
				dir_index_column2,
				dir_index_column3,
				'employment-types': employmentType,

				search,
				page
			} = filters

			const groupIds = chapter_id.reduce((prev, next) => {
				return `${prev}&chapter_id[]=${next}`
			}, '')

			let queryString = `&filter=${filter}${groupIds}&page=${page}&expand=public&category_id=${+this.$route.query.category_id}`

			if (search !== undefined && search.length > 0) {
				queryString += `&search=${search}`
			}

			if (dir_index_column1 !== undefined && !_.isEmpty(dir_index_column1)) {
				const ids = dir_index_column1.reduce((prev, next) => {
					return `${prev}&dir_index_column1[]=${next}`
				}, '')

				queryString += `${ids}`
			}

			if (dir_index_column2 !== undefined && !_.isEmpty(dir_index_column2)) {
				const ids = dir_index_column2.reduce((prev, next) => {
					return `${prev}&dir_index_column2[]=${next}`
				}, '')

				queryString += `${ids}`
			}

			if (dir_index_column3 !== undefined && !_.isEmpty(dir_index_column3)) {
				const ids = dir_index_column3.reduce((prev, next) => {
					return `${prev}&dir_index_column3[]=${next}`
				}, '')

				queryString += `${ids}`
			}

			if (employmentType !== undefined && !_.isEmpty(employmentType)) {
				const ids = employmentType.reduce((prev, next) => {
					return `${prev}&employment-types[]=${next}`
				}, '')

				queryString += `${ids}`
			}

			return queryString
		},

		closeModal() {
			this.showModal = false
			const mutuallyExclusiveButtons = ['clear']

			switch (this.currentActiveButton) {
				case 'employment_types':
					this.currentActiveButton = 'employment_types'

					this.selectedEmploymentTypes = []
					this.filters = {
						...this.filters,
						employmentTypes: [],
					}

					break;
				case 'dir_index_column1':
					this.currentActiveButton = 'dir_index_column1'

					this.selectedDirIndexColumn1 = []
					this.filters = {
						...this.filters,
						dirIndexColumn1: [],
					}

					break;
				case 'dir_index_column2':
					this.currentActiveButton = 'dir_index_column2'

					this.selectedDirIndexColumn2 = []
					this.filters = {
						...this.filters,
						dirIndexColumn2: [],
					}

					break;
				case 'dir_index_column3':
					this.currentActiveButton = 'dir_index_column3'

					this.selectedDirIndexColumn3 = []
					this.filters = {
						...this.filters,
						dirIndexColumn3: [],
					}

					break;
				case 'chapters':
					this.currentActiveButton = 'chapters'

					this.selectedChapters = []
					this.filters = {
						...this.filters,
						groups: [],
					}

					break;
			}

			this.selectedButton = this.getFilteredChips(
				this.selectedButton,
				this.currentActiveButton,
				mutuallyExclusiveButtons
			)
		},

		setSelectedItems(item) {
			const {listItem, selectedType, idColumnName = 'id'} = item

			this.setDynamicItems(listItem, selectedType, idColumnName)
		},
		setDynamicItems(item, selectedType, idColumnName) {
			if (this[selectedType].includes(item[idColumnName])) {
				this[selectedType] = this[selectedType].filter(
					(itemFilter) => itemFilter !== item[idColumnName],
				)
			} else {
				this[selectedType] = [...this[selectedType], item[idColumnName]]
			}
		},

		applySelection() {
			this.filters.groups = this.selectedChapters
			this.filters.employmentTypes = this.selectedEmploymentTypes

			this.filters.dirIndexColumn1 = this.selectedDirIndexColumn1
			this.filters.dirIndexColumn2 = this.selectedDirIndexColumn2
			this.filters.dirIndexColumn3 = this.selectedDirIndexColumn3

			this.showModal = false
		},

		filterSearch(e) {
			clearTimeout(this.timer)

			const params = {
				filter: this.filters.filter,
				chapter_id: this.filters.groups,

				dir_index_column1: this.filters.dirIndexColumn1,
				dir_index_column2: this.filters.dirIndexColumn2,
				dir_index_column3: this.filters.dirIndexColumn3,
				'employment-types': this.filters.employmentTypes,

				search: e.target.value,
				page: 1,
			}
			this.filters.page = 1
			const queryString = this.formatFilters(params)

			this.timer = setTimeout(() => {
				this.getDirectories(queryString)
			}, DEBOUNCE_TIMEOUT)
		},
	},
	created() {
		if (!this.isBlocked || this.isBlocked === null) {
			this.getListsMeta()
			if (this.$route.query.category_id) {
				const params = {
					page: 1,
				}
				this.filters.page = 1
				const queryString = this.formatFilters(params)
	
				this.getDirectories(queryString)
			}
		}
	},

	computed: {
		...mapGetters('auth', ['isAuthenticated']),
		...mapGetters('tag', ['tags']),
		...mapGetters('settings', ['appCore']),
		...mapGetters('directory', ['directories', 'pageDirectories', 'isLoading']),
		...mapGetters('list', ['listsMeta', 'lists']),

		redirectBaseUrl() {
			if (!this.appCore) {
				return [];
			}
			return this.appCore.appMenuNormalized.baseMenuItems.find(item => item.route.name === 'directory');
		},

		isCategoryIdNotSet() {
			return !this.$route.query.hasOwnProperty('category_id');
		},

		normalizedFeedFilterChips() {
			if (!this.appCore) {
				return {}
			}

			const {chips = []} = this.appCore.appMenuNormalized.baseMenuItems.find(item => {
				const {route: {name, query: queryCurrentObjectParams}} = item

				if (name === 'directory') {
					const queryCurrentParams = _.cloneDeepWith(this.$route.query, (value) => {
						return _.isObject(value) ? undefined : Number(value);
					});
					const planeQueryCurrentObjectParams = _.cloneDeepWith(queryCurrentObjectParams, (value) => {
						return _.isObject(value) ? undefined : Number(value);
					})

					return _.isEqualWith(queryCurrentParams, planeQueryCurrentObjectParams, (value1, value2) => {
						if (_.isObject(value1) && _.isObject(value2)) {
							return _.isEqual(_.sortBy(value1), _.sortBy(value2));
						}
					})
				}
			}) || {};

			const isChipsEmpty = chips.length <= 1 && chips.some(item => item.name === 'clear')

			if (isChipsEmpty) {
				this.isShowChips = false;
			}

			return chips
		},

		categoryId() {
			if (this.$route.query.category_id) {
				return this.$route.query.category_id
			}

			return false;
		},

		directoriesNormalize() {
			return this.directories || [];
		},
	},
	watch: {
		appCore: {
			handler(appCore) {
				if (!this.$route.query.category_id && appCore) {
					const {route} = this.redirectBaseUrl || {}

					this.$router.push({
						name: route.name,
						query: route.query
					})
				}
			},
			immediate: true
		},

		"$route.query.category_id": function() {
			this.filters = {
				search: '',
				filter: null,
				chapter_id: [],
				page: 1,
			}
			this.selectedButton = ['clear']
			this.isShowChips = true;

			const params = {
				page: 1,
			}
			this.filters.page = 1
			const queryString = this.formatFilters(params)

			this.getDirectories(queryString);
		},
		'filters.filter': function(val) {
			const params = {
				filter: val,
				chapter_id: this.filters.groups,

				dir_index_column1: this.filters.dirIndexColumn1,
				dir_index_column2: this.filters.dirIndexColumn2,
				dir_index_column3: this.filters.dirIndexColumn3,
				'employment-types': this.filters.employmentTypes,

				search: this.filters.search,
				page: 1,
			}
			this.filters.page = 1
			const queryString = this.formatFilters(params)
			this.getDirectories(queryString)
		},
		'filters.groups': function(next = [], prev = []) {
			const isValuesEmptyOrEqual = (next.length <= 0 && prev.length <= 0) ||
				(_.isEqual(next, prev))

			if (isValuesEmptyOrEqual) {
				return false
			}

			const params = {
				filter: this.filters.filter,
				chapter_id: next,

				dir_index_column1: this.filters.dirIndexColumn1,
				dir_index_column2: this.filters.dirIndexColumn2,
				dir_index_column3: this.filters.dirIndexColumn3,
				'employment-types': this.filters.employmentTypes,

				search: this.filters.search,
				page: 1,
			}
			this.filters.page = 1
			const queryString = this.formatFilters(params)
			this.getDirectories(queryString)
		},
		'filters.dirIndexColumn1': function(next = [], prev = []) {
			const isValuesEmptyOrEqual = (next.length <= 0 && prev.length <= 0) ||
				(_.isEqual(next, prev))

			if (isValuesEmptyOrEqual) {
				return false
			}

			const params = {
				filter: this.filters.filter,
				chapter_id: this.filters.groups,

				dir_index_column1: next,
				dir_index_column2: this.filters.dirIndexColumn2,
				dir_index_column3: this.filters.dirIndexColumn3,
				'employment-types': this.filters.employmentTypes,

				search: this.filters.search,
				page: 1,
			}

			this.filters.page = 1
			const queryString = this.formatFilters(params)
			this.getDirectories(queryString)
		},
		'filters.dirIndexColumn2': function(next = [], prev = []) {
			const isValuesEmptyOrEqual = (next.length <= 0 && prev.length <= 0) ||
				(_.isEqual(next, prev))

			if (isValuesEmptyOrEqual) {
				return false
			}

			const params = {
				filter: this.filters.filter,
				chapter_id: this.filters.groups,

				dir_index_column1: this.filters.dirIndexColumn1,
				dir_index_column2: next,
				dir_index_column3: this.filters.dirIndexColumn3,
				'employment-types': this.filters.employmentTypes,

				search: this.filters.search,
				page: 1,
			}

			this.filters.page = 1
			const queryString = this.formatFilters(params)
			this.getDirectories(queryString)
		},
		'filters.dirIndexColumn3': function(next = [], prev = []) {
			const isValuesEmptyOrEqual = (next.length <= 0 && prev.length <= 0) ||
				(_.isEqual(next, prev))

			if (isValuesEmptyOrEqual) {
				return false
			}

			const params = {
				filter: this.filters.filter,
				chapter_id: this.filters.groups,

				dir_index_column1: this.filters.dirIndexColumn1,
				dir_index_column2: this.filters.dirIndexColumn2,
				dir_index_column3: next,
				'employment-types': this.filters.employmentTypes,

				search: this.filters.search,
				page: 1,
			}

			this.filters.page = 1
			const queryString = this.formatFilters(params)
			this.getDirectories(queryString)
		},
		'filters.employmentTypes': function(next = [], prev = []) {
			const isValuesEmptyOrEqual = (next.length <= 0 && prev.length <= 0) ||
				(_.isEqual(next, prev))

			if (isValuesEmptyOrEqual) {
				return false
			}

			const params = {
				filter: this.filters.filter,
				chapter_id: this.filters.groups,

				dir_index_column1: this.filters.dirIndexColumn1,
				dir_index_column2: this.filters.dirIndexColumn2,
				dir_index_column3: this.filters.dirIndexColumn3,
				'employment-types': next,

				search: this.filters.search,
				page: 1,
			}

			this.filters.page = 1
			const queryString = this.formatFilters(params)
			this.getDirectories(queryString)
		},

		selectedButton(cur) {
			if (cur.length === 0) {
				this.selectedButton = ['clear']
			}
		},
	},

	mounted() {
		window.addEventListener('scroll', this.toggleVisibility)
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.toggleVisibility)
		this.clearAttendeesEvent()
		this.clearLists()
	},

	data() {
		return {
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
			isVisible: false,
			timer: 0,
			filters: {
				filter: null,

				groups: [],

				employmentTypes: [],
				dirIndexColumn1: [],
				dirIndexColumn2: [],
				dirIndexColumn3: [],

				page: 1,
				search: '',
			},
			searchIcon,
			selectedButton: ['clear'],

			currentActiveButton: '',
			currentActiveButtonTitle: '',

			showModal: false,
			isShowChips: true,

			selectedChapters: [],
			selectedDirIndexColumn1: [],
			selectedDirIndexColumn2: [],
			selectedDirIndexColumn3: [],
			selectedEmploymentTypes: [],

			selectedGender: '',
			search: '',
			page: '',
			searchValue: '',
			chapters: '',

			showError: false,
			error: '',
			pageBlockedName: 'directory'
		}
	},
}
</script>

<style lang='scss'>
.events-page {
	background: #f1f1f1 !important;

	&__divider {
		border-color: #000 !important;
		mix-blend-mode: normal;
		opacity: 0.1;
	}

	&__time {
		color: rgb(74, 74, 74);
		font-size: 24px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
	}

	.event {
		&__search {
			background: white;
			height: 54px;
			border-radius: 10px;
			border: 1px solid rgb(230, 230, 230);
			max-width: 600px;
		}

		&__filters {
			color: white;
			font-size: 14px;
			font-family: Montserrat, sans-serif;
			font-weight: bold;
			letter-spacing: 0.36px;
			margin-top: 20px;
			background: rgb(65, 161, 216) !important;
			border-radius: 15px;
			box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
			text-transform: capitalize !important;
			align-items: center;
		}

		@media screen and (max-width: 1264px) {
			&__search {
				max-width: none;
			}
		}
	}

	.post {
		&__search {
			background: white;
			height: 54px;
			border-radius: 10px;
			border: 1px solid rgb(230, 230, 230);
			max-width: 600px;
		}

		&__btn-filters {
			color: var(--chip-text-normal) !important;
			font-size: 14px;
			font-family: Montserrat, sans-serif;
			font-weight: bold;
			letter-spacing: 0.36px;
			margin-top: 20px;

			background-color: var(--chip-normal-background) !important;

			border-radius: 15px;
			box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
			text-transform: capitalize !important;
			align-items: center;
			margin-right: 15px;

			&-active {
				background-color: var(--chip-selected-background) !important;
				color: var(--chip-text-selected) !important;
			}
		}

		@media screen and (max-width: 1264px) {
			&__search {
				max-width: none;
				width: 100%;
			}
		}
	}
}
</style>

